import { render, staticRenderFns } from "./DisplayImage.vue?vue&type=template&id=ef7556b0&scoped=true&"
import script from "./DisplayImage.vue?vue&type=script&lang=js&"
export * from "./DisplayImage.vue?vue&type=script&lang=js&"
import style0 from "./DisplayImage.vue?vue&type=style&index=0&id=ef7556b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7556b0",
  null
  
)

export default component.exports